import {Action} from 'redux';
import {createAction} from '@reduxjs/toolkit';

export const SEND_MESSAGE = 'SEND_MESSAGE';

export const sendMessage = createAction<SendMessagePayload>(SEND_MESSAGE);

type SendMessagePayload = any;

export interface SendMessageAction extends Action {
    payload: SendMessagePayload;
}
